
export enum ActionTypes {
  Withdrawal = 100
}

export const handleActionCompleted = (actionType: ActionTypes, actionId: string, text: string) => {
  switch (actionType) {
    case ActionTypes.Withdrawal: {
      console.log(`withdrawal ${actionId} is complete`);
      $(`#withdrawal-wallet-button[data-action-id="${actionId}"]`).html(
        "<span class='mr-1' role='status' aria-hidden='true'></span> " + text);
      break;
    }
    default: {
      console.error('not supported action type: ', actionType);
    }
  }
}
